import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Container = styled.div`
  height: 100%;
`;

export const StyledSideNav = styled.div`
  position: sticky;
  top: ${({ bound }) => `${bound}px`};
  padding: 50px 0 70px 0;
  display: flex;
  flex-direction: column;
  margin-left: 40px;

  @media ${sizes.extraLargeDesktop} {
    margin-left: 80px;
    max-width: 300px;
  }
`;

export const NavLink = styled.a`
  margin: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: ${({ $active }) => ($active ? th('colors.orange') : th('colors.blue'))};
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: ${th('colors.orange')};
  }

  :not(:first-child) {
    margin-top: 20px;
  }
`;
